import { useEffect } from 'react';

/**
 * Connects an active image modal pan gesture to window-level mouse events.
 */
export const useImageModalV2WindowPanListeners = ({
    endPan,
    isPanning,
    updatePan,
}: {
    endPan: () => void;
    isPanning: boolean;
    updatePan: (point: { x: number; y: number }) => void;
}): void => {
    /**
     * Tracks the pointer outside the image bounds until the drag pan gesture ends.
     */
    useEffect(() => {
        if (!isPanning) return undefined;

        const onMouseMove = (event: MouseEvent) => {
            updatePan({ x: event.clientX, y: event.clientY });
        };
        const onMouseUp = () => {
            endPan();
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);

        return () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [endPan, isPanning, updatePan]);
};
